import store from '../store';
import {AuthorizationUtils} from '../utils/AuthorizationUtils';

function getConfig() {
  const state = store.getState();

  return state.app.config;
}

function getHeaders() {
  const config = getConfig();

  return {
    'Content-Type': 'application/json',
    'Authorization': AuthorizationUtils.base64(config.environment.merchantId, config.environment.apiKey)
  }
}

function get(url) {
  const config = getConfig();

  return fetch(`${config.api.baseUrl}${url}`, {
    method: 'GET',
    headers: getHeaders()
  }).then(response => response.json());
}

export const HttpService = {
	get
};


// WEBPACK FOOTER //
// ./src/http/HttpService.js